import React from 'react'
import { css } from '@emotion/react'

import mediaQueries from 'gatsby-theme-marketplace-base/src/layout/media-queries'

import TopRow from './TopRow'
import BottomRow from './BottomRow'
import PolicyDisclaimer from './PolicyDisclaimer'

const containerCss = (theme) => css`
  width: 100%;
  color: ${theme.colors.white};
  background-color: ${theme.colors.black};
  padding: 0 16px;

  ${mediaQueries.smallScreen()} {
    padding: 0 32px;
  }
`

const separatorCss = (theme) => css`
  width: 100%;
  height: 1px;
  background-color: ${theme.colors.black100};
  border: none;
  margin: 0;
`

const footerCss = (theme) => css`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  row-gap: 4rem;
  max-width: ${theme.maxWidth};
  margin: 0 auto;
  padding-block: 3rem;

  ${mediaQueries.smallScreen()} {
    padding-inline: 32px;
  }

  p {
    margin: 0;
  }
`

const Footer = () => {
  return (
    <footer>
      <div css={containerCss}>
        <div css={footerCss}>
          <TopRow />
          <BottomRow />
        </div>
      </div>
      <hr css={separatorCss} />
      <div css={containerCss}>
        <PolicyDisclaimer />
      </div>
    </footer>
  )
}

export default Footer
